import { render, staticRenderFns } from "./SedeCampusUniversitario.vue?vue&type=template&id=d65bc390"
import script from "./SedeCampusUniversitario.vue?vue&type=script&lang=js"
export * from "./SedeCampusUniversitario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports